
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/global-fashion-industry-statistics",
      function () {
        return require("private-next-pages/global-fashion-industry-statistics.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/global-fashion-industry-statistics"])
      });
    }
  